import { RulebookModel } from '.';

export class BulkRulebookData {
  rulebookIds: Array<number>;
  rulebooks: Array<RulebookModel>;

  constructor(){
    this.rulebookIds = [];
    this.rulebooks = [];
  }
}
